import axios from './axios';
import {HINTS_URL} from '../config/api';
import {getValidToken, authFormDataHeader, authHeader} from './getValidToken';
import store from '../store';
import {
  uploadStart,
  uploadFinish,
  uploadProgress
} from '../reducers/uploadReducer';


export async function saveDocument(file, type) {
  const token = await getValidToken();
  const data = new FormData();
  data.append('file', file);
  return axios.post(`${HINTS_URL}/HintsService/v1.0/rest/ecommerce/customer/upload/${type}`, data, {
    ...authFormDataHeader(token),
    onUploadProgress(progressEvent) {
      const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
      const state = store.getState().upload;
      if (!state.inProgress) store.dispatch(uploadStart());
      if (percentCompleted !== 100) store.dispatch(uploadProgress(percentCompleted));
      if (percentCompleted === 100) store.dispatch(uploadFinish());
    }
  });
}

export async function getDocument(type) {
  const token = await getValidToken();
  return axios.get(`${HINTS_URL}/HintsService/v1.0/rest/ecommerce/customer/documents/${type}`, authFormDataHeader(token));
}

export async function downloadImage(url) {
  return axios.get(url, {
    onDownloadProgress(progressEvent) {
      const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
      const state = store.getState().upload;
      if (!state.inProgress) store.dispatch(uploadStart());
      if (percentCompleted !== 100) store.dispatch(uploadProgress(percentCompleted));
      if (percentCompleted === 100) store.dispatch(uploadFinish());
    }
  });
}

export async function removeDocument(type) {
  const token = await getValidToken();
  return axios.post(`${HINTS_URL}/HintsService/v1.0/rest/ecommerce/remove/${type}`, null, authHeader(token));
}



// WEBPACK FOOTER //
// ./src/services/upload.js